import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { createGlobalStyle } from 'styled-components';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { HOSTNAME, IS_CLIENT, UI_VERSION } from '@constants';
import { ON_CHANGE_LANG } from '@constants/observer';
import { MainHead } from './Main-Head';
import { ui } from './ui';

export const DemoLayout = ({ title, children }) => {
  const { locale } = useSelector((state) => state.settings);

  useEffect(() => {
    if (IS_CLIENT) {
      const script = document.createElement('script');

      script.src = `https://ui.${HOSTNAME}/static/js/site.js?v${UI_VERSION}`;
      script.async = true;
      script.defer = true;

      document.head.appendChild(script);

      script.onload = () => {
        ui.connectTranslations();
        ui.initObserver({ locale });
        ui.initGallery({ locale });
      };

      // обновляем те модули, которые зависят от языка
      ui.addEventListener(ON_CHANGE_LANG, () => {
        ui.reinitGallery({ locale });
      });
    }
  }, []);

  return (
    <>
      <GlobalStyle />
      <MainHead title={title} />
      <main>{children}</main>
      <div id="modal" />
    </>
  );
};

const GlobalStyle = createGlobalStyle`
  html {
    height: 100%;
  }

  body {
    background-color: ${Colors.azure};
    height: 100%;

    > * {
      height: 100%;
    }
  }
  
  main {
    position: relative;
    height: 100%;
    min-width: 1024px;
  }
`;
